import client from './client';

export const bizuApi = {
  getAll: () => client.get('/bizu'),
  getById: (id) => client.get(`/bizu/${id}`),
  getStats: (name) => client.get(`/bizu/stats/${name}`),
  getQuesoLibrary: (userId) => client.get(`/bizu/queso/library/${userId}`),
  getKienPlayedRecipes: (userId) => client.get(`/bizu/kien/played-recipes/${userId}`),
  getKienUserRecipes: (userId) => client.get(`/bizu/kien/user-recipes/${userId}`),
  create: (data) => client.post('/bizu', data),
  update: (id, data) => client.put(`/bizu/${id}`, data),
  delete: (id) => client.delete(`/bizu/${id}`),
  seed: () => client.post('/bizu/seed')
};
